import React, { useContext } from "react";
import Slider from "react-slick";
import { ApplicationContext } from "@context/ApplicationContext";
import PlayIcon from "@components/Icons/PlayIcon";
import TrailerButton from "@components/TrailerButton";
import Loader from "@components/Ui/Loader";
import "./style.scss";

const FeatureFilm = () => {
    const { featureFilm, isLoadingFeatureFilms } = useContext(ApplicationContext);

    const settings = {
        dots: true,
        arrows: false,
        autoplay: true,
        infinite: true,
        speed: 600,
        initialSlide: 0,
        autoplaySpeed: 7000,
        cssEase: "ease-in-out",
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    if (isLoadingFeatureFilms) return <Loader />;
    if (!featureFilm || featureFilm.length === 0) return null;

    if (featureFilm.length === 1) {
        const film = featureFilm[0];
        return (
            <div className="feature-film__container">
                <div className="feature-film__list">
                    <div className="feature-film__wrapper">
                        <a className="feature-film__link" href={film.feature_url} target="_blank" rel="noreferrer">
                            <picture>
                                <source media="(min-width: 1025px)" srcSet={film.image_url} />
                                <img className="feature-film__image" src={film.mobile_image_url} alt={film.description} />
                            </picture>
                        </a>
                        {film.trailer_url && (
                            <TrailerButton extraClass="trailer-button" type="youtube" trailerLink={film.trailer_url}>
                                <PlayIcon className="trailer-button__svg" />
                                <span className="trailer-button__button-text">Official Trailer</span>
                            </TrailerButton>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="feature-film__container">
            <div className="feature-film__list">
                <Slider {...settings}>
                    {featureFilm.map((film, i) => (
                        <div key={`${film.id}-${i}`} className="feature-film__wrapper">
                            <a
                                href={film.feature_url}
                                target="_blank"
                                rel="noreferrer"
                                className="feature-film__link"
                            >
                                <picture>
                                    <source media="(min-width: 1025px)" srcSet={film.image_url} />
                                    <img className="feature-film__image" src={film.mobile_image_url} alt={film.description} />
                                </picture>
                            </a>
                            {film.trailer_url && (
                                <TrailerButton
                                    extraClass="trailer-button trailer-button--official-trailer"
                                    type="youtube"
                                    trailerLink={film.trailer_url}
                                >
                                    <PlayIcon className="trailer-button__svg" />
                                    <span className="trailer-button__button-text">Official Trailer</span>
                                </TrailerButton>
                            )}
                        </div>
                    ))}
                </Slider>
            </div>
        </div>
    );
};

export default FeatureFilm;
